import { Coin } from "../../../cosmos/base/v1beta1/coin";
import { Metadata } from "../../../cosmos/bank/v1beta1/bank";
import * as _m0 from "protobufjs/minimal";
/**
 * MsgCreateDenom defines the message structure for the CreateDenom gRPC service
 * method. It allows an account to create a new denom. It requires a sender
 * address and a sub denomination. The (sender_address, sub_denomination) tuple
 * must be unique and cannot be re-used.
 * 
 * The resulting denom created is defined as
 * <factory/{creatorAddress}/{subdenom}>. The resulting denom's admin is
 * originally set to be the creator, but this can be changed later. The token
 * denom does not indicate the current admin.
 */

function createBaseMsgCreateDenom() {
  return {
    sender: "",
    subdenom: ""
  };
}

export const MsgCreateDenom = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",

  encode(message, writer = _m0.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.subdenom !== "") {
      writer.uint32(18).string(message.subdenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateDenom();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.subdenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender, _object$subdenom;

    const message = createBaseMsgCreateDenom();
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.subdenom = (_object$subdenom = object.subdenom) !== null && _object$subdenom !== void 0 ? _object$subdenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      subdenom: object.subdenom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.subdenom = message.subdenom;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateDenom.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/create-denom",
      value: MsgCreateDenom.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateDenom.decode(message.value);
  },

  toProto(message) {
    return MsgCreateDenom.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenom",
      value: MsgCreateDenom.encode(message).finish()
    };
  }

};

function createBaseMsgCreateDenomResponse() {
  return {
    newTokenDenom: ""
  };
}

export const MsgCreateDenomResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenomResponse",

  encode(message, writer = _m0.Writer.create()) {
    if (message.newTokenDenom !== "") {
      writer.uint32(10).string(message.newTokenDenom);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateDenomResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.newTokenDenom = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$newTokenDenom;

    const message = createBaseMsgCreateDenomResponse();
    message.newTokenDenom = (_object$newTokenDenom = object.newTokenDenom) !== null && _object$newTokenDenom !== void 0 ? _object$newTokenDenom : "";
    return message;
  },

  fromAmino(object) {
    return {
      newTokenDenom: object.new_token_denom
    };
  },

  toAmino(message) {
    const obj = {};
    obj.new_token_denom = message.newTokenDenom;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgCreateDenomResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/create-denom-response",
      value: MsgCreateDenomResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgCreateDenomResponse.decode(message.value);
  },

  toProto(message) {
    return MsgCreateDenomResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgCreateDenomResponse",
      value: MsgCreateDenomResponse.encode(message).finish()
    };
  }

};

function createBaseMsgMint() {
  return {
    sender: "",
    amount: undefined,
    mintToAddress: ""
  };
}

export const MsgMint = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",

  encode(message, writer = _m0.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.amount !== undefined) {
      Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
    }

    if (message.mintToAddress !== "") {
      writer.uint32(26).string(message.mintToAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgMint();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.amount = Coin.decode(reader, reader.uint32());
          break;

        case 3:
          message.mintToAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender2, _object$mintToAddress;

    const message = createBaseMsgMint();
    message.sender = (_object$sender2 = object.sender) !== null && _object$sender2 !== void 0 ? _object$sender2 : "";
    message.amount = object.amount !== undefined && object.amount !== null ? Coin.fromPartial(object.amount) : undefined;
    message.mintToAddress = (_object$mintToAddress = object.mintToAddress) !== null && _object$mintToAddress !== void 0 ? _object$mintToAddress : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      amount: object !== null && object !== void 0 && object.amount ? Coin.fromAmino(object.amount) : undefined,
      mintToAddress: object.mintToAddress
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
    obj.mintToAddress = message.mintToAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgMint.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/mint",
      value: MsgMint.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgMint.decode(message.value);
  },

  toProto(message) {
    return MsgMint.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMint",
      value: MsgMint.encode(message).finish()
    };
  }

};

function createBaseMsgMintResponse() {
  return {};
}

export const MsgMintResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMintResponse",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgMintResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgMintResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgMintResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/mint-response",
      value: MsgMintResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgMintResponse.decode(message.value);
  },

  toProto(message) {
    return MsgMintResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgMintResponse",
      value: MsgMintResponse.encode(message).finish()
    };
  }

};

function createBaseMsgBurn() {
  return {
    sender: "",
    amount: undefined,
    burnFromAddress: ""
  };
}

export const MsgBurn = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",

  encode(message, writer = _m0.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.amount !== undefined) {
      Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
    }

    if (message.burnFromAddress !== "") {
      writer.uint32(26).string(message.burnFromAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBurn();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.amount = Coin.decode(reader, reader.uint32());
          break;

        case 3:
          message.burnFromAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender3, _object$burnFromAddre;

    const message = createBaseMsgBurn();
    message.sender = (_object$sender3 = object.sender) !== null && _object$sender3 !== void 0 ? _object$sender3 : "";
    message.amount = object.amount !== undefined && object.amount !== null ? Coin.fromPartial(object.amount) : undefined;
    message.burnFromAddress = (_object$burnFromAddre = object.burnFromAddress) !== null && _object$burnFromAddre !== void 0 ? _object$burnFromAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      amount: object !== null && object !== void 0 && object.amount ? Coin.fromAmino(object.amount) : undefined,
      burnFromAddress: object.burnFromAddress
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
    obj.burnFromAddress = message.burnFromAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgBurn.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/burn",
      value: MsgBurn.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBurn.decode(message.value);
  },

  toProto(message) {
    return MsgBurn.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurn",
      value: MsgBurn.encode(message).finish()
    };
  }

};

function createBaseMsgBurnResponse() {
  return {};
}

export const MsgBurnResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurnResponse",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBurnResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgBurnResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgBurnResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/burn-response",
      value: MsgBurnResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgBurnResponse.decode(message.value);
  },

  toProto(message) {
    return MsgBurnResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgBurnResponse",
      value: MsgBurnResponse.encode(message).finish()
    };
  }

};

function createBaseMsgChangeAdmin() {
  return {
    sender: "",
    denom: "",
    newAdmin: ""
  };
}

export const MsgChangeAdmin = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",

  encode(message, writer = _m0.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    if (message.newAdmin !== "") {
      writer.uint32(26).string(message.newAdmin);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChangeAdmin();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.denom = reader.string();
          break;

        case 3:
          message.newAdmin = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender4, _object$denom, _object$newAdmin;

    const message = createBaseMsgChangeAdmin();
    message.sender = (_object$sender4 = object.sender) !== null && _object$sender4 !== void 0 ? _object$sender4 : "";
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.newAdmin = (_object$newAdmin = object.newAdmin) !== null && _object$newAdmin !== void 0 ? _object$newAdmin : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      denom: object.denom,
      newAdmin: object.new_admin
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.denom = message.denom;
    obj.new_admin = message.newAdmin;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChangeAdmin.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/change-admin",
      value: MsgChangeAdmin.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChangeAdmin.decode(message.value);
  },

  toProto(message) {
    return MsgChangeAdmin.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdmin",
      value: MsgChangeAdmin.encode(message).finish()
    };
  }

};

function createBaseMsgChangeAdminResponse() {
  return {};
}

export const MsgChangeAdminResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdminResponse",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgChangeAdminResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgChangeAdminResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgChangeAdminResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/change-admin-response",
      value: MsgChangeAdminResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgChangeAdminResponse.decode(message.value);
  },

  toProto(message) {
    return MsgChangeAdminResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgChangeAdminResponse",
      value: MsgChangeAdminResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetBeforeSendHook() {
  return {
    sender: "",
    denom: "",
    cosmwasmAddress: ""
  };
}

export const MsgSetBeforeSendHook = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",

  encode(message, writer = _m0.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }

    if (message.cosmwasmAddress !== "") {
      writer.uint32(26).string(message.cosmwasmAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetBeforeSendHook();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.denom = reader.string();
          break;

        case 3:
          message.cosmwasmAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender5, _object$denom2, _object$cosmwasmAddre;

    const message = createBaseMsgSetBeforeSendHook();
    message.sender = (_object$sender5 = object.sender) !== null && _object$sender5 !== void 0 ? _object$sender5 : "";
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.cosmwasmAddress = (_object$cosmwasmAddre = object.cosmwasmAddress) !== null && _object$cosmwasmAddre !== void 0 ? _object$cosmwasmAddre : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      denom: object.denom,
      cosmwasmAddress: object.cosmwasm_address
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.denom = message.denom;
    obj.cosmwasm_address = message.cosmwasmAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetBeforeSendHook.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/set-before-send-hook",
      value: MsgSetBeforeSendHook.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetBeforeSendHook.decode(message.value);
  },

  toProto(message) {
    return MsgSetBeforeSendHook.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHook",
      value: MsgSetBeforeSendHook.encode(message).finish()
    };
  }

};

function createBaseMsgSetBeforeSendHookResponse() {
  return {};
}

export const MsgSetBeforeSendHookResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHookResponse",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetBeforeSendHookResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetBeforeSendHookResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetBeforeSendHookResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/set-before-send-hook-response",
      value: MsgSetBeforeSendHookResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetBeforeSendHookResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetBeforeSendHookResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetBeforeSendHookResponse",
      value: MsgSetBeforeSendHookResponse.encode(message).finish()
    };
  }

};

function createBaseMsgSetDenomMetadata() {
  return {
    sender: "",
    metadata: undefined
  };
}

export const MsgSetDenomMetadata = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",

  encode(message, writer = _m0.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetDenomMetadata();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.metadata = Metadata.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender6;

    const message = createBaseMsgSetDenomMetadata();
    message.sender = (_object$sender6 = object.sender) !== null && _object$sender6 !== void 0 ? _object$sender6 : "";
    message.metadata = object.metadata !== undefined && object.metadata !== null ? Metadata.fromPartial(object.metadata) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      metadata: object !== null && object !== void 0 && object.metadata ? Metadata.fromAmino(object.metadata) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.metadata = message.metadata ? Metadata.toAmino(message.metadata) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetDenomMetadata.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/set-denom-metadata",
      value: MsgSetDenomMetadata.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetDenomMetadata.decode(message.value);
  },

  toProto(message) {
    return MsgSetDenomMetadata.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadata",
      value: MsgSetDenomMetadata.encode(message).finish()
    };
  }

};

function createBaseMsgSetDenomMetadataResponse() {
  return {};
}

export const MsgSetDenomMetadataResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadataResponse",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetDenomMetadataResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgSetDenomMetadataResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgSetDenomMetadataResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/set-denom-metadata-response",
      value: MsgSetDenomMetadataResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgSetDenomMetadataResponse.decode(message.value);
  },

  toProto(message) {
    return MsgSetDenomMetadataResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgSetDenomMetadataResponse",
      value: MsgSetDenomMetadataResponse.encode(message).finish()
    };
  }

};

function createBaseMsgForceTransfer() {
  return {
    sender: "",
    amount: undefined,
    transferFromAddress: "",
    transferToAddress: ""
  };
}

export const MsgForceTransfer = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",

  encode(message, writer = _m0.Writer.create()) {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }

    if (message.amount !== undefined) {
      Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
    }

    if (message.transferFromAddress !== "") {
      writer.uint32(26).string(message.transferFromAddress);
    }

    if (message.transferToAddress !== "") {
      writer.uint32(34).string(message.transferToAddress);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgForceTransfer();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;

        case 2:
          message.amount = Coin.decode(reader, reader.uint32());
          break;

        case 3:
          message.transferFromAddress = reader.string();
          break;

        case 4:
          message.transferToAddress = reader.string();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$sender7, _object$transferFromA, _object$transferToAdd;

    const message = createBaseMsgForceTransfer();
    message.sender = (_object$sender7 = object.sender) !== null && _object$sender7 !== void 0 ? _object$sender7 : "";
    message.amount = object.amount !== undefined && object.amount !== null ? Coin.fromPartial(object.amount) : undefined;
    message.transferFromAddress = (_object$transferFromA = object.transferFromAddress) !== null && _object$transferFromA !== void 0 ? _object$transferFromA : "";
    message.transferToAddress = (_object$transferToAdd = object.transferToAddress) !== null && _object$transferToAdd !== void 0 ? _object$transferToAdd : "";
    return message;
  },

  fromAmino(object) {
    return {
      sender: object.sender,
      amount: object !== null && object !== void 0 && object.amount ? Coin.fromAmino(object.amount) : undefined,
      transferFromAddress: object.transferFromAddress,
      transferToAddress: object.transferToAddress
    };
  },

  toAmino(message) {
    const obj = {};
    obj.sender = message.sender;
    obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
    obj.transferFromAddress = message.transferFromAddress;
    obj.transferToAddress = message.transferToAddress;
    return obj;
  },

  fromAminoMsg(object) {
    return MsgForceTransfer.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/force-transfer",
      value: MsgForceTransfer.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgForceTransfer.decode(message.value);
  },

  toProto(message) {
    return MsgForceTransfer.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransfer",
      value: MsgForceTransfer.encode(message).finish()
    };
  }

};

function createBaseMsgForceTransferResponse() {
  return {};
}

export const MsgForceTransferResponse = {
  typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransferResponse",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgForceTransferResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseMsgForceTransferResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return MsgForceTransferResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/tokenfactory/force-transfer-response",
      value: MsgForceTransferResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MsgForceTransferResponse.decode(message.value);
  },

  toProto(message) {
    return MsgForceTransferResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.tokenfactory.v1beta1.MsgForceTransferResponse",
      value: MsgForceTransferResponse.encode(message).finish()
    };
  }

};